import React from 'react';
import { 
  Paper, 
  Typography, 
  Box, 
  LinearProgress, 
  IconButton, 
  Chip 
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SpeedIcon from '@mui/icons-material/Speed';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface StreamingIndicatorProps {
  isActive: boolean;
  progress: number;
  contentType: string;
  estimatedTime?: number;
  wordsPerMinute?: number;
  onCancel?: () => void;
}

/**
 * StreamingIndicator Component
 * 
 * Shows real-time progress of content generation with cancellation option.
 * Displays progress bar, speed metrics, and estimated completion time.
 * 
 * NOTE: Temporarily disabled per user request - not showing purple progress section while streaming
 */
const StreamingIndicator: React.FC<StreamingIndicatorProps> = ({
  isActive,
  progress,
  contentType,
  estimatedTime = 0,
  wordsPerMinute = 0,
  onCancel
}) => {
  // User requested to not show the purple progress section while streaming
  return null;
};

export default StreamingIndicator; 